import { normalizedTrackingStatusMessages } from '@/parcels/constants'
import { isInboundParcel, isTrackingParcel } from '@/parcels/helpers/helpers'

export const getLabel = (labels, labelTrackingNumber) => {
  return labels?.find(label => label.tracking_number === labelTrackingNumber) || null
}

export const getNormalizedTrackingStatusMessage = (parcelStatus, normalizedTrackingStatus) => {
  return normalizedTrackingStatusMessages?.[parcelStatus]?.[normalizedTrackingStatus]
}

export const canSplitParcel = parcel => {
  return parcel?.related?.line_items?.length > 1 && !isInboundParcel(parcel) && !isTrackingParcel(parcel)
}
